module.exports = __webpack_public_path__ + "static/media/entry_splash.f4fa8094.png";